export default __webpack_public_path__ + "static/media/google-play-store.c2231c85.svg";